<!-- Navbar start -->
<div class="fixed-top">
  <div class=" topbar bg-primary d-none d-lg-block">
    <div class="d-flex justify-content-between">
      <div class="top-info ps-2">
        <small class="me-3"><i class="fas fa-mobile-alt me-2 text-secondary"></i> <a href="#"
            class="text-white">5558249337</a></small>
        <small class="me-3"><i class="fas fa-mobile-alt me-2 text-secondary"></i> <a href="#"
            class="text-white">5518167618</a></small>
        <small class="me-3"><i class="fas fa-envelope me-2 text-secondary"></i><a href="#"
            class="text-white">contacto&#64;acozam.com</a></small>
      </div>
      <div class="top-link pe-2">
        <a href="#" class="text-white"><small class="text-white ms-2">Corporativo Biomedico Acozam S. A. de C.
            V.</small></a>
      </div>
    </div>
  </div>

  <div class="px-0">
    <nav class="navbar navbar-light bg-white navbar-expand-xl">
      <a href="index.html" class="navbar-brand">
        <img width="180" height="60" src="../assets/img/AcozamLogo_300x126.png" class="custom-logo" alt=""
          decoding="async" srcset="../assets/img/AcozamLogo_300x126.png">
      </a>
      <button class="navbar-toggler py-2 px-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
        <span class="fa fa-bars text-primary"></span>
      </button>
      <div class="collapse navbar-collapse bg-white" id="navbarCollapse">
        <div class="navbar-nav mx-auto">
          <a href="index.html" class="nav-item nav-link active">Inicio</a>
          <a href="/about" class="nav-item nav-link">Nosotros</a>
          <a href="/shop" class="nav-item nav-link">Tienda</a>
          <a href="/contact" class="nav-item nav-link">Contáctanos</a>
        </div>
        <div class="d-flex m-3">
          <a href="/cart" class="position-relative my-auto mx-3">
            <i class="fa fa-shopping-bag fa-2x"></i>
            <span
              class="position-absolute bg-secondary rounded-circle d-flex align-items-center justify-content-center text-dark px-1"
              style="top: -5px; left: 15px; height: 20px; min-width: 20px;">{{chartProducts}}</span>
          </a>
          @if(isTokenExpired) {
            <a (click)="showDialog()" class="my-auto mx-3">
              <i class="fas fa-user fa-2x"></i>
            </a>
            } @else {
            <a class="my-auto mx-3"
              href="https://api.whatsapp.com/send?phone=+525562922378&amp;text= Hola!%20Quiero%20información"
              target="_blank">
              <i class="fab fa-whatsapp fa-2x"></i>
            </a>
            <p-menubar class="mx-3" [model]="items" />
            }
        </div>
      </div>
    </nav>
  </div>
</div>
<p-toast />

<!-- Login Section -->
<p-dialog [header]="modalHeader" (onHide)="showSection('close')" [modal]="true" [(visible)]="visible"
  [style]="{ width: '35rem' }">
  <!-- Login -->
  <form [formGroup]="session" *ngIf="islogin">
    <div class="flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">Correo: </label>
      <input type="email" id="mail" name="mail" class="form-control" formControlName="mail" required>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="password" class="font-semibold w-6rem">Contraseña: </label>
      <input type="password" id="password" name="password" class="form-control" formControlName="password" required>
    </div>

    <div class="flex align-items-center gap-3 mb-2">
      <a href="#" (click)="showSection('user')">Registrate</a>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <a href="#" (click)="showSection('password')">¿Olvidaste tu contraseña?</a>
    </div>
    <div class="d-flex btn-container gap-2">
      <p-button label="Enviar" class="mr-3 me-auto" [disabled]="info.mail?.invalid || info.password?.invalid"
        (click)="login()" />
      <p-button label="Cancelar" severity="secondary" (click)="showSection('close')" />
    </div>
  </form>

  <!-- New User -->
  <form [formGroup]="newRegister" *ngIf="isNewUser">
    <div class="my-4">
      Para continuar con su registro, introduzca la siguiente información:
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="name" class="font-semibold w-6rem">Nombre/Razón Social: </label>
      <input type="text" id="name" name="name" class="form-control" formControlName="name" required>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">Correo: </label>
      <input type="email" id="mail" name="mail" class="form-control" formControlName="mail" required>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">Teléfono: </label>
      <input type="email" id="mail" name="mail" class="form-control" formControlName="phone" required>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="password" class="font-semibold w-6rem">Nueva Contraseña: </label>
      <p-password weakLabel="Simple" mediumLabel="Medio" strongLabel="Fuerte" [toggleMask]="true"
        [style]="{'width': '100% !important'}" formControlName="password" (onBlur)="setPass($event)">
      </p-password>
      <ul class="pl-2 mt-2" style=" font-size: 12px;">
        <li [ngClass]="{'haveLower':haveLower}">Al menos una Mayúscula</li>
        <li [ngClass]="{'haveUpper':haveUpper}">Al menos una minúscula</li>
        <li [ngClass]="{'haveNumber':haveNumber}">Al menos un número</li>
        <li [ngClass]="{'haveLength':haveLength}">Mínimo 8 caracteres</li>
        @if ( newRegister.controls['password'].dirty && newRegister.controls['passwordConfirm'].dirty && !isValidPassword ) {
          <li class="text-danger">La contraseña no coincide</li>
        }
      </ul>
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">Confirmar Contraseña: </label>
      <input type="password" id="passwordConfirm" name="passwordConfirm" class="form-control" (blur)="setPassword()"
        formControlName="passwordConfirm" required>
    </div>

    <div>
      <app-adress-form [isNew]="true" (adress)="getAddress($event)" (isValidAddress)="getIsValidInfo($event)"></app-adress-form>
    </div>

    <div class="d-flex btn-container gap-2">
      <p-button label="Enviar" class="mr-3 me-auto"
        [disabled]="infoRegister.name?.invalid || infoRegister.mail?.invalid || infoRegister.password?.invalid || !isValidPassword || !isValidAddress"
        (click)="registerUser()" />
      <p-button label="Cancelar" severity="secondary" (click)="showSection('close')" />
    </div>
  </form>

  <!-- Password Recovery -->
  <form [formGroup]="newPassword" *ngIf="isPasswordForgotten">
    <div class="my-4">
      Introduzca su correo electrónico registrado, a continuación le enviaremos un correo para seguir con el proceso.
    </div>
    <div class="flex align-items-center gap-3 mb-3">
      <label for="username" class="font-semibold w-6rem">Correo: </label>
      <input type="email" id="mail" name="mail" class="form-control" formControlName="mail" required>
    </div>
    <div class="d-flex btn-container mt-2 gap-2">
      <p-button label="Enviar" class="mr-3 me-auto" [disabled]="infoPassword.mail?.invalid"
        (click)="changePassword()" />
      <p-button label="Cancelar" severity="secondary" (click)="showSection('close')" />
    </div>
  </form>
</p-dialog>

<!-- Navbar End -->

<!-- Modal Search Start -->
<div class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content rounded-0">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Search by keyword</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body d-flex align-items-center">
        <div class="input-group w-75 mx-auto d-flex">
          <input type="search" class="form-control p-3" placeholder="keywords" aria-describedby="search-icon-1">
          <span id="search-icon-1" class="input-group-text p-3"><i class="fa fa-search"></i></span>
        </div>
      </div>
    </div>
  </div>
</div>
